import { Badge } from '@/components/ui/badge';

export const zonasColumns = [
  {
    id: 'nombre',
    label: 'Nombre',
    type: 'text',
    sortable: true,
    required: true,
    placeholder: 'Ej: Norte, Sur, Centro',
    render: (row) => <span className="font-medium">{row.nombre || 'N/A'}</span>,
  },
  {
    id: 'descripcion',
    label: 'Descripción',
    type: 'textarea',
    sortable: false,
    required: false,
    placeholder: 'Descripción de la zona (opcional)',
    render: (row) => <span className="text-muted-foreground">{row.descripcion || 'Sin descripción'}</span>,
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
    render: (row) => (
      <Badge variant={row.estado === 'Activo' ? 'default' : 'secondary'}>
        {row.estado}
      </Badge>
    ),
  },
  {
    id: 'opciones',
    label: 'Opciones',
    width: '10%',
    actions: [
      {
        key: 'edit',
        icon: 'Edit',
        tooltip: 'Editar zona',
        className: 'text-muted-foreground hover:text-foreground',
      },
      {
        key: 'delete',
        icon: 'Trash',
        tooltip: 'Eliminar zona',
        className: 'text-muted-foreground hover:text-foreground',
      },
    ],
  },
];

export const columnsExcel = [
  { header: 'Nombre', key: 'nombre' },
  { header: 'Descripción', key: 'descripcion' },
  { header: 'Estado', key: 'estado' },
];
